/**
 * Muted, earthy segment colors for Recharts (dashboard pies, etc.).
 * Chosen for distinction on parchment card backgrounds while staying on-brand.
 */
export const CHART_SEGMENT_COLORS = [
  '#3d5c4a',
  '#8b5a3c',
  '#5c5348',
  '#7a6b2d',
  '#3d5a73',
  '#6b4a5a',
  '#4a5d6b',
  '#7a5c3a',
  '#4f5a40',
  '#5a5046',
];
